import { gql } from "@apollo/client";
export const UPDATESETTINGS = gql`
  mutation updateSettings($key: String!, $value: String!) {
    setSetting(key: $key, value: $value) {
      id
    }
  }
`;

export const GET_PRINTERS = gql`
  query getPrinters($branch_id: Int) {
    getPrinters(branch_id: $branch_id) {
      id
      ip_address
      port
    }
  }
`;

export const ADD_PRINTER = gql`
  mutation addPrinter($branch_id: Int!, $ip_address: String!, $port: String!) {
    addPrinter(branch_id: $branch_id, ip_address: $ip_address, port: $port) {
      id
      ip_address
      port
    }
  }
`;

export const UPDATE_PRINTER = gql`
  mutation updatePrinter($id: Int!, $ip_address: String!, $port: String!) {
    updatePrinter(id: $id, ip_address: $ip_address, port: $port) {
      id
      ip_address
      port
    }
  }
`;

export const DELETE_PRINTER = gql`
  mutation deletePrinter($id: Int!) {
    deletePrinter(id: $id)
  }
`;
